<template>
  <div class="add-wrap">
    <Form :formData="formData" :isEdit="false" />
  </div>
</template>

<script>
import Form from "./components/form.vue";
export default {
  created() {
    //模拟异步触发draw-form组件的watch事件
    setTimeout(() => {
      this.formData = {
        topic_name: "",
        course_number:'',//课程的节数
        slogan:'',
        topic_cover: "",
        publicity_cover: "",
        card_cover:'',
        topic_sell_mode: 1,
        topic_sell_price: "",
        // home_page_banner: 1,
        state: 1,
        topic_type: "1",
        course_introduction: "",
        course_audience: "",
        common_problem: "",
        published_at: "",
        course_ids:[]
      };
    });
  },
  data() {
    return {
      formData: {}
    };
  },
  components: {
    Form
  }
};
</script>

<style lang="less">
</style>
